import React, { useEffect, useRef, useState } from 'react'
import { withPage } from '@sms/plasma-ui';
import IFrameComponent from '../../../components/IFramePage/IFrameComponent';

export interface AuditTrailsPageProps {
  children?: React.ReactNode;
  relativePath: string;
}

const VeroPage = (props: AuditTrailsPageProps) => {
  const { relativePath } = props;

  const envVars: Record<string, unknown> = typeof window === "undefined" ? process.env
  : (window as any).plasma.environment

  return (
    <>
      <div style={{ height: '100%', width: '100%' }}>
        <IFrameComponent key={'iframe-audit-trails'} option={relativePath} elementId='iframe-audit-trails' source={envVars.AUDIT_TRAILS_IFRAME_URL} needsReload={true} />
      </div>
    </>
  )
}

export default withPage(VeroPage);
